import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CreateTipoTramiteDependenciaRequest, IGetTipoTramitesByDependencia, ITipoTramite } from '../../../../../shared/interfaces/database/configuracion';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { TipoTramiteDependenciaService } from '../../../../../services/database/tipoTramiteDependencia.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { TipoTramiteService } from '../../../../../services/database/tipoTramite.service';
import { ButtonModule } from 'primeng/button';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { AccessRole, ButtonColumnType, CustomTableComponent, DataColumnType, ICustomTable, IDropdownSelect, IHeader, LoadingPanelService, LocalService } from 'lib-base';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';

@Component({
  selector: 'app-admin-tipo-tramite-dependencia',
  standalone: true,
  imports: [
    CommonModule, FormsModule,
    TableModule, CheckboxModule, DropdownModule, ButtonModule, ConfirmPopupModule, CustomTableComponent
  ],
  providers: [ConfirmationService],
  templateUrl: './admin-tipo-tramite-dependencia.component.html',
  styleUrls: ['./admin-tipo-tramite-dependencia.component.scss']
})
export class AdminTipoTramiteDependenciaComponent implements OnInit {
  @Input() dependenciaId!: number;

  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  role = AccessRole;
  trans: any = {};

  constructor(
    private readonly _ttd: TipoTramiteDependenciaService, private readonly _tt: TipoTramiteService, public ls: LocalService,
    private readonly _ms: MessageService, private readonly _cs: ConfirmationService, private readonly _t: TranslateService, private readonly _lps: LoadingPanelService
  ) {
  }

  ngOnInit(): void {
    this.translate();
    this.getTipoTramitesByDependencias();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      title: this._t.get('common.tramites'),
      tramite: this._t.get('common.tramite'),
      requiereRolSeguridad: this._t.get('msg.requiere-rol-seguridad'),
      agregado: this._t.get('_common.agregado'),
      eliminado: this._t.get('_common.eliminado'),
      exito: this._t.get('common.exito')
    }));

    this.customTable = {
      columns: [
        {
          field: 'tipoTramiteDescripcion',
          header: 'Tramite',
          sort: true,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'tipoTramiteProduccion',
          header: 'Produccion',
          sort: true,
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          dataType: DataColumnType.CHECK
        },
        {
          field: 'delete',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-0',
          buttonType: ButtonColumnType.DELETE,
          disabled: !this.ls.hasRole(this.role.ADMIN_TRAM),
          tooltip: {
            message: this.trans.requiereRolSeguridad
          },
          onClick: (event: Event, data: IGetTipoTramitesByDependencia) => this.deleteConfirmation(event, data),
        }
      ],
      settings: {
        table: {
          rows: 5,
        }
      }
    } as ICustomTable;
  }

  deleteConfirmation(event: Event, ids: any) {
    this._cs.confirm({
      target: event.target as EventTarget,
      message: 'Estas seguro de que quieres eliminar el tramite?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteTramiteFromDependencia(ids.dependenciaId, ids.tipoTramiteId)
      }
    });
  }

  //#region API
  addTramite(data: ITipoTramite) {
    let newTipoTramiteDependencia = {
      dependenciaId: this.dependenciaId,
      tipoTramiteId: data.id
    } as CreateTipoTramiteDependenciaRequest;
    this._lps.show(true);
    this._ttd.addTipoTramiteToDependencia(newTipoTramiteDependencia).subscribe({
      next: () => {
        this._lps.hide();
        this.getTipoTramitesByDependencias();
        this.getTiposTramites();
        this._ms.add({ severity: 'success', summary: 'Éxito', detail: this.trans.tramite + this.trans.agregado });
      }
    });
  }

  getTipoTramitesByDependencias() {
    this._ttd.getTipoTramitesByDependencias(this.dependenciaId).subscribe({
      next: (tramites: IGetTipoTramitesByDependencia[]) => {
        this.customTableComponent.data = tramites;
        this.getTiposTramites();
      }
    });
  }

  getTiposTramites() {
    this._tt.getTipoTramitesSinDependencia().subscribe({
      next: (data: ITipoTramite[]) => {
        let dropdown = {
          data: data.filter(t => !this.customTableComponent.data.some(td => td.tipoTramiteId === t.id)),
          label: 'descripcion',
          disabled: !this.ls.hasRole(this.role.ADMIN_TRAM),
          onBtnClick: (event: Event, data: any) => this.addTramite(data),
        } as IDropdownSelect

        this.customTableComponent.setHeaderDropdownSelect(dropdown);
      }
    });
  }

  deleteTramiteFromDependencia(dependenciaId: number, tipoTramiteId: number) {
    this._lps.show(true);
    this._ttd.deleteTramiteFromDependencia(dependenciaId, tipoTramiteId).subscribe({
      next: () => {
        this._lps.hide();
        this.getTipoTramitesByDependencias();
        this.getTiposTramites();
        this._ms.add({ severity: 'success', summary: 'Éxito', detail: this.trans.tramite + this.trans.eliminado });
      },
      error: (error: HttpErrorResponse) => {
        this._ms.add({ severity: 'error', summary: error.error, detail: error.message });
      }
    });
  }
  //#endregion
}
